import saveUserToLocal from "@/common/function/saveUserToLocal";
import * as userRequest from "@/utils/userRequest";

export default async function fetchMaxoutService(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) {
  try {
    const res = await userRequest.get("max-out/user", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("🚀 ~ fetchMaxoutService ~ res:", res);
    if (res) {
      onSuccess && onSuccess(res?.data);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ fetchMaxoutService ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
